import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import s from '../../PaperworkList.module.css';
import FunctionalButtonPanel, {
	FunctionalButton,
} from '../../../../Components/FunctionalButtonPanel/FunctionalButtonPanel';
import {
	CashierType,
	SupplierType,
} from '../../../../types/CashierSliceStateType';
import {useTranslation} from 'react-i18next';
import PaperWorkCashPopup, {CashPopupType} from '../../PaperWorkCashPopup';
import AuthCashierPopup from '../../../../Components/AuthCashierPopup/AuthCashierPopup';
import {toast} from 'react-toastify';

import {
	useCloseCasherShiftMutation,
	useExitCasherMutation,
	useGetLogisticListQuery,
	useOpenCasherShiftMutation,
} from '../../../../redux/DepotSlice/depotCashierApi';
import {useNavigate} from 'react-router-dom';
type Props = {
	currentCashier: CashierType | null;
	setCurrentCashier: Dispatch<SetStateAction<CashierType | null>>;
	supplier: SupplierType;
};
const PrroBlock: React.FC<Props> = ({
	currentCashier,
	setCurrentCashier,
	supplier,
}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();

	const [functionality, setFunctionality] = useState<FunctionalButton[] | null>(
		null,
	);
	const [shiftIsOpen, setShiftIsOpen] = useState(false);
	const [cashPopup, setCashPopup] = useState<CashPopupType | null>(null);
	const [openCashPopup, setOpenCashPopup] = useState(false);
	const [authPopup, setAuthPopup] = useState(false);
	const [exitCasher] = useExitCasherMutation();
	const [openCasherShift] = useOpenCasherShiftMutation();
	const [closeCasherShift] = useCloseCasherShiftMutation();

	// Теперь работаем с одним поставщиком
	const currentSupplier = supplier;
	const handleExitCasher = async (id: string) => {
		try {
			const response = await exitCasher({cashier_id: +id}).unwrap();
			toast.success(response?.message?.textmsg || t('Успішно'));
			setCurrentCashier(null);
		} catch (error: any) {
			toast.error(error?.data?.message?.textmsg || t('Помилка'));
		}
	};

	// Получаем кассиров этого поставщика
	const cashiersList = currentSupplier?.cashiers ?? [];

	// Удалена функция handleChangeSupplier - больше не нужна
	const handleOpenCashierShift = async (id: string) => {
		try {
			const response = await openCasherShift({cashier_id: +id}).unwrap();
			setShiftIsOpen(true);
			toast.success(response?.message?.textmsg || t('Успішно'));
		} catch (error: any) {
			toast.error(error?.data?.message?.textmsg || t('Помилка'));
		}
	};
	const handleCloseCasherShift = async (id: string, shiftId: string) => {
		try {
			const response = await closeCasherShift({
				cashier_id: +id,
				shift_id: shiftId,
			}).unwrap();
			toast.success(response?.message?.textmsg || t('Успішно'));
			setShiftIsOpen(false);
		} catch (error: any) {
			toast.error(error?.data?.message?.textmsg || t('Помилка'));
		}
	};
	const handleCashAction = (type: string, shiftId: string) => {
		setOpenCashPopup(true);
		switch (type) {
			case 'deposit':
				setCashPopup({
					title: t('Внести готівку'),
					type,
					shift_id: shiftId,
				});
				break;
			case 'withdrawal':
				setCashPopup({
					title: t('Зняти готівку'),
					type,
					shift_id: shiftId,
				});
				break;
		}
	};
	// Удален useEffect для выбора поставщика - теперь работаем с одним поставщиком

	// Проверка открытых кассиров и установка кнопок
	useEffect(() => {
		if (!cashiersList.length) return;

		const openCashier = cashiersList.find((c) => c.open_cashier || c.shift_id);
		setCurrentCashier(openCashier ?? null);

		if (openCashier && !openCashier.shift_id) {
			const id = openCashier.cashier_id.toString();
			setFunctionality([
				{
					name: t('Відкрити зміну'),
					value: id,
					func: handleOpenCashierShift,
				},
				{
					name: t('Вийти з касира'),
					value: id,
					func: handleExitCasher,
					color: 'blue',
				},
			]);
		} else if (openCashier && openCashier.shift_id) {
			const shiftId = openCashier.shift_id;
			const cashierId = openCashier.cashier_id.toString();
			setShiftIsOpen(true);
			setFunctionality([
				{
					name: t('Внести готівку'),
					value: 'deposit',
					func: () => handleCashAction('deposit', shiftId),
				},
				{
					name: t('Зняти готівку'),
					value: 'withdrawal',
					func: () => handleCashAction('withdrawal', shiftId),
				},
				{
					name: `z-${t('звіт')}`,
					value: 'z-report-list',
					func: () => navigate(`/report-page/z-report-list/list`),
				},
				{
					name: `x-${t('звіт')}`,
					value: 'x-report',
					func: () => navigate(`/report-page/x-report/${shiftId}`),
				},
				{
					name: t('Закрити зміну'),
					value: 'close-shift',
					func: () => handleCloseCasherShift(cashierId, shiftId),
				},
			]);
		} else {
			setFunctionality([
				{
					name: t('Авторизувати касира'),
					value: 'auth',
					func: () => setAuthPopup(true),
				},
			]);
		}
	}, [cashiersList]);

	if (!supplier) return null;
	return (
		<div>
			{openCashPopup && cashPopup && (
				<PaperWorkCashPopup
					popup={cashPopup}
					close={() => setOpenCashPopup(false)}
				/>
			)}
			{authPopup && currentSupplier && (
				<AuthCashierPopup
					supplierId={currentSupplier?.supplier_id}
					close={() => setAuthPopup(false)}
				/>
			)}
		<div className={s.buttonsPanelWrapper}>
			{shiftIsOpen && (
				<div className={s.cashierInfo}>
					<span>{t('Зміна відкрита')}:</span>
					<span>{currentCashier?.shift_date}</span>
					<span>|</span>
					<span>{t('Касир')}:</span>
					<span>{currentCashier?.cashier_name}</span>
				</div>
			)}
			{currentCashier && !shiftIsOpen && (
				<div className={s.cashierInfo}>
					<span>{t('Касир')}:</span>
					<span>{currentCashier?.cashier_name}</span>
				</div>
			)}
			{functionality && (
				<FunctionalButtonPanel
					elWidth={'0 0 25%'}
					functionality={functionality}
				/>
			)}
		</div>
		</div>
	);
};

export default PrroBlock;
